import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query'
import { TUseMutationOptions, TUseQueryOptions, TCustomUseQueryMeta } from 'core/query/type'
import {
  TPostEntrustPlanOrderPlaceParams,
  TPostEntrustPlanOrderPlaceResponse,
  postEntrustPlanOrderPlace,
  TGetEntrustPlanOrderPlaceParams,
  TGetEntrustPlanOrderPlaceResponse,
  getEntrustPlanOrderPlace,
  TGetPopupPutStatusParams,
  TGetPopupPutStatusResponse,
  getPopupPutStatus,
  TGetPopupGetStatusParams,
  TGetPopupGetStatusResponse,
  getPopupGetStatus,
  TGetCoinInfoListParams,
  TGetCoinInfoListResponse,
  getCoinInfoList,
  TGetEntrustTopListParams,
  TGetEntrustTopListResponse,
  getEntrustTopList,
  TGetEntrustLogListParams,
  TGetEntrustLogListResponse,
  getEntrustLogList,
  TGetEntrustTradeFillsParams,
  TGetEntrustTradeFillsResponse,
  getEntrustTradeFills,
  TGetEntrustTradeHistoryParams,
  TGetEntrustTradeHistoryResponse,
  getEntrustTradeHistory,
  TGetEntrustOpenOrdersParams,
  TGetEntrustOpenOrdersResponse,
  getEntrustOpenOrders,
  TGetTestEntrustPlanOrderPlaceParams,
  TGetTestEntrustPlanOrderPlaceResponse,
  getTestEntrustPlanOrderPlace,
  TPostTestEntrustPlanOrderPlaceParams,
  TPostTestEntrustPlanOrderPlaceResponse,
  postTestEntrustPlanOrderPlace,
  TGetPublicTradeTipsParams,
  TGetPublicTradeTipsResponse,
  getPublicTradeTips,
  TGetSymbolLabelInfoTestParams,
  TGetSymbolLabelInfoTestResponse,
  getSymbolLabelInfoTest,
  TGetEntrustListParams,
  TGetEntrustListResponse,
  getEntrustList,
  TGetEntrustDetailParams,
  TGetEntrustDetailResponse,
  getEntrustDetail,
  TGetSymbolListParams,
  TGetSymbolListResponse,
  getSymbolList,
  TGetSymbolLabelInfoParams,
  TGetSymbolLabelInfoResponse,
  getSymbolLabelInfo,
  TGetTradeLabelListParams,
  TGetTradeLabelListResponse,
  getTradeLabelList,
} from 'core/service/yapi/hk-web/HotcoinControllerV3/api'
// 币币优化
// 计划委托下单
export const usePostEntrustPlanOrderPlaceMutation = (
  mutationOptions?: TUseMutationOptions<TPostEntrustPlanOrderPlaceResponse, TPostEntrustPlanOrderPlaceParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['HotcoinControllerV3', 'EntrustPlanOrderPlace', 'Post'],
    mutationFn: (params?: TPostEntrustPlanOrderPlaceParams) =>
      postEntrustPlanOrderPlace(params, mutationOptions?.meta?.requestOptions),
  })
}

// 计划委托下单
export const useGetEntrustPlanOrderPlaceQuery = (
  params?: TGetEntrustPlanOrderPlaceParams,
  options?: TUseQueryOptions<TGetEntrustPlanOrderPlaceResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV3', 'EntrustPlanOrderPlace', 'GET', ...Object.values(params || {})],
    queryFn: () => getEntrustPlanOrderPlace(params, options?.meta?.requestOptions),
  })
}

// 是否关闭弹窗--存
export const useGetPopupPutStatusQuery = (
  params?: TGetPopupPutStatusParams,
  options?: TUseQueryOptions<TGetPopupPutStatusResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV3', 'PopupPutStatus', 'GET', ...Object.values(params || {})],
    queryFn: () => getPopupPutStatus(params, options?.meta?.requestOptions),
  })
}

// 是否关闭弹窗--取
export const useGetPopupGetStatusQuery = (
  params?: TGetPopupGetStatusParams,
  options?: TUseQueryOptions<TGetPopupGetStatusResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV3', 'PopupGetStatus', 'GET', ...Object.values(params || {})],
    queryFn: () => getPopupGetStatus(params, options?.meta?.requestOptions),
  })
}

// 查询coin信息
export const useGetCoinInfoListQuery = (
  params?: TGetCoinInfoListParams,
  options?: TUseQueryOptions<TGetCoinInfoListResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV3', 'CoinInfoList', 'GET', ...Object.values(params || {})],
    queryFn: () => getCoinInfoList(params, options?.meta?.requestOptions),
  })
}

// 交易页分页查询委托
export const useGetEntrustTopListQuery = (
  params?: TGetEntrustTopListParams,
  options?: TUseQueryOptions<TGetEntrustTopListResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV3', 'EntrustTopList', 'GET', ...Object.values(params || {})],
    queryFn: () => getEntrustTopList(params, options?.meta?.requestOptions),
  })
}

// 根据委托id查询订单成交明细列表
export const useGetEntrustLogListQuery = (
  params?: TGetEntrustLogListParams,
  options?: TUseQueryOptions<TGetEntrustLogListResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV3', 'EntrustLogList', 'GET', ...Object.values(params || {})],
    queryFn: () => getEntrustLogList(params, options?.meta?.requestOptions),
  })
}

// 根据多条件查询订单成交明细列表
export const useGetEntrustTradeFillsQuery = (
  params?: TGetEntrustTradeFillsParams,
  options?: TUseQueryOptions<TGetEntrustTradeFillsResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV3', 'EntrustTradeFills', 'GET', ...Object.values(params || {})],
    queryFn: () => getEntrustTradeFills(params, options?.meta?.requestOptions),
  })
}

// 根据多条件查询订单成交历史列表
export const useGetEntrustTradeHistoryQuery = (
  params?: TGetEntrustTradeHistoryParams,
  options?: TUseQueryOptions<TGetEntrustTradeHistoryResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV3', 'EntrustTradeHistory', 'GET', ...Object.values(params || {})],
    queryFn: () => getEntrustTradeHistory(params, options?.meta?.requestOptions),
  })
}

// 当前委托订单数量
export const useGetEntrustOpenOrdersQuery = (
  params?: TGetEntrustOpenOrdersParams,
  options?: TUseQueryOptions<TGetEntrustOpenOrdersResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV3', 'EntrustOpenOrders', 'GET', ...Object.values(params || {})],
    queryFn: () => getEntrustOpenOrders(params, options?.meta?.requestOptions),
  })
}

// 计划委托下单
export const useGetTestEntrustPlanOrderPlaceQuery = (
  params?: TGetTestEntrustPlanOrderPlaceParams,
  options?: TUseQueryOptions<TGetTestEntrustPlanOrderPlaceResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV3', 'TestEntrustPlanOrderPlace', 'GET', ...Object.values(params || {})],
    queryFn: () => getTestEntrustPlanOrderPlace(params, options?.meta?.requestOptions),
  })
}

// 计划委托下单
export const usePostTestEntrustPlanOrderPlaceMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostTestEntrustPlanOrderPlaceResponse,
    TPostTestEntrustPlanOrderPlaceParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['HotcoinControllerV3', 'TestEntrustPlanOrderPlace', 'Post'],
    mutationFn: (params?: TPostTestEntrustPlanOrderPlaceParams) =>
      postTestEntrustPlanOrderPlace(params, mutationOptions?.meta?.requestOptions),
  })
}

// 查询币对币对提示事件
export const useGetPublicTradeTipsQuery = (
  params?: TGetPublicTradeTipsParams,
  options?: TUseQueryOptions<TGetPublicTradeTipsResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV3', 'PublicTradeTips', 'GET', ...Object.values(params || {})],
    queryFn: () => getPublicTradeTips(params, options?.meta?.requestOptions),
  })
}

// 查询币对信息和标签信息-test
export const useGetSymbolLabelInfoTestQuery = (
  params?: TGetSymbolLabelInfoTestParams,
  options?: TUseQueryOptions<TGetSymbolLabelInfoTestResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV3', 'SymbolLabelInfoTest', 'GET', ...Object.values(params || {})],
    queryFn: () => getSymbolLabelInfoTest(params, options?.meta?.requestOptions),
  })
}

// 全部订单分页查询委托
export const useGetEntrustListQuery = (
  params?: TGetEntrustListParams,
  options?: TUseQueryOptions<TGetEntrustListResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV3', 'EntrustList', 'GET', ...Object.values(params || {})],
    queryFn: () => getEntrustList(params, options?.meta?.requestOptions),
  })
}

// 查询订单委托详情
export const useGetEntrustDetailQuery = (
  params?: TGetEntrustDetailParams,
  options?: TUseQueryOptions<TGetEntrustDetailResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV3', 'EntrustDetail', 'GET', ...Object.values(params || {})],
    queryFn: () => getEntrustDetail(params, options?.meta?.requestOptions),
  })
}

// 查询币对信息
export const useGetSymbolListQuery = (
  params?: TGetSymbolListParams,
  options?: TUseQueryOptions<TGetSymbolListResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV3', 'SymbolList', 'GET', ...Object.values(params || {})],
    queryFn: () => getSymbolList(params, options?.meta?.requestOptions),
  })
}

// 查询币对信息和标签信息
export const useGetSymbolLabelInfoQuery = (
  params?: TGetSymbolLabelInfoParams,
  options?: TUseQueryOptions<TGetSymbolLabelInfoResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV3', 'SymbolLabelInfo', 'GET', ...Object.values(params || {})],
    queryFn: () => getSymbolLabelInfo(params, options?.meta?.requestOptions),
  })
}

// 查询标签信息
export const useGetTradeLabelListQuery = (
  params?: TGetTradeLabelListParams,
  options?: TUseQueryOptions<TGetTradeLabelListResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV3', 'TradeLabelList', 'GET', ...Object.values(params || {})],
    queryFn: () => getTradeLabelList(params, options?.meta?.requestOptions),
  })
}
